import { UserFlow } from '@constants/generic';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import { getLocalStorageItem } from '@utils/storage';

// eslint-disable-next-line import/prefer-default-export
export const getOrganizationId = (userFlow: string) => {
  switch (userFlow) {
    case UserFlow.CREATE_ORG:
      return getLocalStorageItem(LOCAL_STORAGE_KEYS.NEW_ORG_ID) || '';
    case UserFlow.USER_ONBOARD:
      return getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_ORGANIZATION_ID) || '';
    case UserFlow.UPGRADE_TO_ORG:
      return getLocalStorageItem(LOCAL_STORAGE_KEYS.UPGRADED_ORG_ID) || '';
    default:
      return getLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_ID) || '';
  }
};

export const getBranchId = (userFlow: string) => {
  switch (userFlow) {
    case UserFlow.CREATE_ORG:
      return getLocalStorageItem(LOCAL_STORAGE_KEYS.NEW_BRANCH_ID) || '';
    case UserFlow.USER_ONBOARD:
      return getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_BRANCH_ID) || '';
    case UserFlow.UPGRADE_TO_ORG:
      return getLocalStorageItem(LOCAL_STORAGE_KEYS.UPGRADED_BRANCH_ID) || '';
    default:
      return getLocalStorageItem(LOCAL_STORAGE_KEYS.BRANCH_ID) || '';
  }
};
